import React from "react";

// Custom Components
import EntryDataTableTemplate from "../../../../components/DataTable/EntryDataTableTemplate";

const AllEntriesMenuScreen = () => {
  return (
    <EntryDataTableTemplate
      apiPath={"entries/all_menu/"}
      newItemPath={"/entries/none/"}
      dataTableName={"All Entries"}
      showCreateEntryButton={false}
      isAllEntry={true}
    />
  );
};

export default AllEntriesMenuScreen;
